import React, { useState } from "react";
import produce from 'immer';
import auth from "../auth";
import Version from "version";
import globalState from '../state/GlobalState';
import { useState as useGlobalState } from '@hookstate/core';
import ServerState from '../controls/ServerState';
import { useTranslation } from 'react-i18next';
import NavigationHelper from '../utils/NavigationHelper';
import ReactLoading from 'react-loading';
import { useConnect } from 'dotnetify';
import { useTheme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import TopContainer from '../controls/TopContainer';
import { Box, BoxTitle, BoxContent } from '../controls/Box';
import { SmallButton } from '../controls/components/Buttons';
import { Link } from 'react-tiger-transition';
import SparkleDialog from '../controls/components/SparkleDialog';

const nh = NavigationHelper;


export default function InvoiceList() {
    const { state } = useConnect("InvoiceList", {}, {
        headers: {
            Authorization: "Bearer " + auth.getAccessToken(),
            ClientVersion: Version.getVersion(),
            ServerToken: window.sessionStorage.ServerToken
        },
        exceptionHandler: _ => auth.signOut()
    });
    const gstate = useGlobalState(globalState);
    const { t } = useTranslation();
    const [localState, internalSetLocalState] = useState({ disabled: false, busy: false, showBuyDataButton: false, dialogOpen: false });
    const setLocalState = (o) => {
        internalSetLocalState(
            produce(draft => {
                draft[Object.keys(o)[0]] = Object.values(o)[0];
            })
        )
    }
    const theme = useTheme();
    const setTopLevelInfo = function () {
        var ci = gstate.currentIndex.get();
        var cn = t(nh.getPageName(ci));
        var cp = nh.getPageUrl(ci);
        gstate.topModuleName.set(cn);
        gstate.topModuleUrl.set(cp);
    }
    const handleCloseDialog = () => {
        setLocalState({ dialogOpen: false });
    }
    const isPrepaid = gstate.PackageType.get() === 'prepaid';

    return (
        <React.Fragment>
            <ServerState serverState={state} localState={localState} setLocalState={setLocalState} />
            <SparkleDialog open={localState.dialogOpen} handleClose={handleCloseDialog} type={localState.dialogType} />
            <TopContainer title={state.IsNorway ? isPrepaid ? 'Forbruk' : 'Faktura' : 'Fakturor' } noSelect>
                {state.IsNorway && !isPrepaid &&
                    <Box border>
                        <BoxTitle>
                            Foreløpig kostnader for neste faktura
                    </BoxTitle>
                        <BoxContent>

                            {!state.Unbilled ?
                                <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={30} width={50} />
                                :
                                state.Unbilled.map((row, index) => {
                                    return (
                                        <Grid key={index} container direction="row" justify="space-between" alignItems="center">
                                            <Grid item>
                                                {row.Description === ' ' ? <span>&nbsp;</span> : row.Description}
                                            </Grid>
                                            <Grid item>
                                                {row.Price}
                                            </Grid>
                                        </Grid>
                                    )
                                })}
                        </BoxContent>
                    </Box>}
                {isPrepaid &&
                    <Box border>
                        <BoxTitle>
                            Påfyllingshistorikk
                        </BoxTitle>
                        <BoxContent>
                            {!state.Refills && !state.RefillText ?
                                <ReactLoading type={"bubbles"} color={theme.palette.primary.main} height={30} width={50} />
                                :
                                <>
                                    <div>{state.RefillText}</div>
                                {state.Refills.map((row, index) => {
                                    return (
                                        <Grid key={index} container direction="row" alignItems="center">
                                            <Grid item xs={6}>
                                                {row.Description === ' ' ? <span>&nbsp;</span> : row.Description}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {row.Date}
                                            </Grid>
                                            <Grid item xs={2} style={{ textAlign: 'right' }}>
                                                {row.Amount}
                                            </Grid>
                                        </Grid>
                                    )
                                })}
                                </>
                            }
                        </BoxContent>
                    </Box>}
                <Grid container direction="row" justify="space-between" alignItems="center">
                    {state.Invoices?.map((row, index) => {
                        return (
                            <Box key={index} background>
                                <BoxTitle>
                                    <Grid container direction="row" justify="space-between">
                                        <div>{row.Month}</div>
                                        <div>{row.Amount}</div>
                                    </Grid>
                                </BoxTitle>
                                <Grid container direction="row" justify="space-between" alignItems="baseline" style={{ paddingTop: '17px', fontSize: '14px' }}>
                                    <SmallButton component={Link} replace to={"/invoice-list/invoice?invoiceNo=" + row.InvoiceNo} transition="glide-left" onClick={() => setTopLevelInfo()}>Se mer</SmallButton>
                                    <div><span style={{ color: row.PaymentStatusColor }}>{row.PaymentStatus}</span>{row.PaymentSubStatus && <><span> - </span><span style={{ color: row.PaymentSubStatusColor }}>{row.PaymentSubStatus}</span></>}</div>
                                </Grid>
                            </Box>
                        )
                    })}
                </Grid>
            </TopContainer>
        </React.Fragment>
    );
}